
export const TALOS_ID = 'CUS-c8f0dd3ff1fb49979a15cc7c2e973611ab48f3b43d58fce98535e16d68b2d8ad';
export const MURPHY_ID = 'CUS-4af2b267e3d46165ee865bf5a5eecc2e9fed7d28096fd5898265f53c21ad886f';

export function isTalosCustomer(customerID?: string | null): boolean {
    return customerID === TALOS_ID;
}

export function isMurphyCustomer(customerID?: string | null): boolean {
    return customerID === MURPHY_ID;
}
